module.exports = __webpack_public_path__ + "promotion.85f8ca2b08d4586c5447.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/images/landing/promotion.png
// module id = ../../../../../src/assets/layout/images/landing/promotion.png
// module chunks = 2